module.exports = __webpack_public_path__ + "static/media/poor.6c6ee66a.jpg";